
import { WorldCountry } from '../types';

export const switzerlandExpanded: WorldCountry = {
  code: 'CH',
  name: 'Switzerland',
  slug: 'switzerland',
  population: 8703000,
  topCities: [
    // Major cities
    { name: 'Zurich', slug: 'zurich', population: 421878 },
    { name: 'Geneva', slug: 'geneva', population: 201818 },
    { name: 'Basel', slug: 'basel', population: 177595 },
    { name: 'Bern', slug: 'bern', population: 133883 },
    { name: 'Lausanne', slug: 'lausanne', population: 140202 },
    { name: 'Winterthur', slug: 'winterthur', population: 114220 },
    { name: 'Lucerne', slug: 'lucerne', population: 82257 },
    { name: 'St. Gallen', slug: 'st-gallen', population: 76213 },
    { name: 'Lugano', slug: 'lugano', population: 62315 },
    { name: 'Biel/Bienne', slug: 'biel-bienne', population: 55206 },
    
    // Extended cities to reach 100
    { name: 'Thun', slug: 'thun', population: 43476 },
    { name: 'Köniz', slug: 'koniz', population: 42091 },
    { name: 'La Chaux-de-Fonds', slug: 'la-chaux-de-fonds', population: 38615 },
    { name: 'Schaffhausen', slug: 'schaffhausen', population: 36952 },
    { name: 'Fribourg', slug: 'fribourg', population: 38039 },
    { name: 'Chur', slug: 'chur', population: 36336 },
    { name: 'Vernier', slug: 'vernier', population: 35702 },
    { name: 'Neuchâtel', slug: 'neuchatel', population: 33712 },
    { name: 'Uster', slug: 'uster', population: 35337 },
    { name: 'Sion', slug: 'sion', population: 34978 },
    { name: 'Emmen', slug: 'emmen', population: 30806 },
    { name: 'Zug', slug: 'zug', population: 30934 },
    { name: 'Yverdon-les-Bains', slug: 'yverdon-les-bains', population: 30143 },
    { name: 'Dübendorf', slug: 'dubendorf', population: 28853 },
    { name: 'Dietikon', slug: 'dietikon', population: 27664 },
    { name: 'Montreux', slug: 'montreux', population: 26574 },
    { name: 'Frauenfeld', slug: 'frauenfeld', population: 25490 },
    { name: 'Kreuzlingen', slug: 'kreuzlingen', population: 22518 },
    { name: 'Wädenswil', slug: 'wadenswil', population: 22334 },
    { name: 'Delémont', slug: 'delemont', population: 12591 },
    { name: 'Aarau', slug: 'aarau', population: 21726 },
    { name: 'Bellinzona', slug: 'bellinzona', population: 43360 },
    { name: 'Nyon', slug: 'nyon', population: 21718 },
    { name: 'Kriens', slug: 'kriens', population: 27976 },
    { name: 'Pully', slug: 'pully', population: 18233 },
    { name: 'Wettingen', slug: 'wettingen', population: 20718 },
    { name: 'Renens', slug: 'renens', population: 21056 },
    { name: 'Allschwil', slug: 'allschwil', population: 21518 },
    { name: 'Bulle', slug: 'bulle', population: 23178 },
    { name: 'Horgen', slug: 'horgen', population: 22880 },
    { name: 'Wil', slug: 'wil', population: 24000 },
    { name: 'Gossau', slug: 'gossau', population: 17642 },
    { name: 'Olten', slug: 'olten', population: 18000 },
    { name: 'Pratteln', slug: 'pratteln', population: 16421 },
    { name: 'Lancy', slug: 'lancy', population: 31432 },
    { name: 'Carouge', slug: 'carouge', population: 22232 },
    { name: 'Freienbach', slug: 'freienbach', population: 16003 },
    { name: 'Baar', slug: 'baar', population: 24013 },
    { name: 'Meyrin', slug: 'meyrin', population: 25139 },
    { name: 'Riehen', slug: 'riehen', population: 21297 },
    { name: 'Solothurn', slug: 'solothurn', population: 16777 },
    { name: 'Morges', slug: 'morges', population: 15965 },
    { name: 'Bülach', slug: 'bulach', population: 21718 },
    { name: 'Münchenstein', slug: 'munchenstein', population: 11870 },
    { name: 'Baden', slug: 'baden', population: 19658 },
    { name: 'Arbon', slug: 'arbon', population: 14383 },
    { name: 'Herisau', slug: 'herisau', population: 15438 },
    { name: 'Onex', slug: 'onex', population: 18302 },
    { name: 'Littau', slug: 'littau', population: 17441 },
    { name: 'Rheinfelden', slug: 'rheinfelden', population: 13608 },
    { name: 'Volketswil', slug: 'volketswil', population: 18418 },
    { name: 'Oftringen', slug: 'oftringen', population: 13254 },
    { name: 'Martigny', slug: 'martigny', population: 18174 },
    { name: 'Vevey', slug: 'vevey', population: 19827 },
    { name: 'Monthey', slug: 'monthey', population: 17615 },
    { name: 'Muttenz', slug: 'muttenz', population: 17576 },
    { name: 'Schlieren', slug: 'schlieren', population: 18913 },
    { name: 'Steffisburg', slug: 'steffisburg', population: 16252 },
    { name: 'Versoix', slug: 'versoix', population: 13842 },
    { name: 'Spreitenbach', slug: 'spreitenbach', population: 12234 },
    { name: 'Kloten', slug: 'kloten', population: 20393 },
    { name: 'Wallisellen', slug: 'wallisellen', population: 15405 },
    { name: 'Grenchen', slug: 'grenchen', population: 16847 },
    { name: 'Adliswil', slug: 'adliswil', population: 18411 },
    { name: 'Cham', slug: 'cham', population: 16818 },
    { name: 'Opfikon', slug: 'opfikon', population: 21031 },
    { name: 'Langenthal', slug: 'langenthal', population: 15817 },
    { name: 'Vernier', slug: 'vernier-city', population: 35702 },
    { name: 'Uzwil', slug: 'uzwil', population: 13674 },
    { name: 'Burgdorf', slug: 'burgdorf', population: 16239 },
    { name: 'Sierre', slug: 'sierre', population: 16332 },
    { name: 'Muri bei Bern', slug: 'muri-bei-bern', population: 12656 },
    { name: 'Illnau-Effretikon', slug: 'illnau-effretikon', population: 16746 },
    { name: 'Bassersdorf', slug: 'bassersdorf', population: 12052 },
    { name: 'Reinach', slug: 'reinach', population: 18777 },
    { name: 'Le Locle', slug: 'le-locle', population: 10467 },
    { name: 'Ecublens', slug: 'ecublens', population: 12820 },
    { name: 'Brig-Glis', slug: 'brig-glis', population: 13213 },
    { name: 'Liestal', slug: 'liestal', population: 13968 },
    { name: 'Küsnacht', slug: 'kusnacht', population: 14021 },
    { name: 'Zollikon', slug: 'zollikon', population: 12770 },
    { name: 'Ostermundigen', slug: 'ostermundigen', population: 17118 },
    { name: 'Binningen', slug: 'binningen', population: 15056 },
    { name: 'Gland', slug: 'gland', population: 13658 },
    { name: 'Le Grand-Saconnex', slug: 'le-grand-saconnex', population: 12634 },
    { name: 'Bussigny', slug: 'bussigny', population: 8348 },
    { name: 'Romanshorn', slug: 'romanshorn', population: 11045 },
    { name: 'Meilen', slug: 'meilen', population: 13846 },
    { name: 'Locarno', slug: 'locarno', population: 16057 },
    { name: 'Amriswil', slug: 'amriswil', population: 14019 },
    { name: 'Worb', slug: 'worb', population: 11824 },
    { name: 'Lyss', slug: 'lyss', population: 15206 },
    { name: 'Spiez', slug: 'spiez', population: 12924 }
  ]
};
